import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FaTimes } from "react-icons/fa";
import ReactPlayer from "react-player";
const VideoPopup = ({ successPopUp, closeSuccessDialog, videoUrl }) => {
  return (
    <Dialog open={successPopUp} onClose={closeSuccessDialog}>
      <DialogTitle>
        <div className="row">
          <p className="fs-17 bold">Video Preview</p>
          <div className="col-1 text-right ml-auto">
            <FaTimes
              onClick={(event) => {
                event.stopPropagation();
                closeSuccessDialog();
              }}
              className="crossview cp"
            />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <ReactPlayer
          className="video-popup-player"
          url={videoUrl}
          playing={true}
          controls
        />
      </DialogContent>
    </Dialog>
  );
};

export default VideoPopup;
